import React, {useContext} from 'react';
import {TagContext} from "../../../context/tagContext";
import ThreadListPromote from "../../Forum/ForumView/ThreadListPromote";
import LoadingContent from "../../common/LoadingContent";
import LoadingNoMoreContent from "../../common/LoadingNoMoreContent";

const ResultSection = () => {
	const {
		tag, threads, hasMoreThreads, loadMoreThreads, threadsLoading,
	} = useContext(TagContext);

	if (tag && threads) {
		return (
			<div>
				{threads && threads.length > 0 ? (
					<ThreadListPromote
						threads={threads}
						hasMoreThreads={hasMoreThreads}
						loadMoreThreads={loadMoreThreads}
						threadsLoading={threadsLoading}
					/>
				) : (
					<div>
						{threadsLoading ? (
							<LoadingContent />
						) : (
							<LoadingNoMoreContent />
						)}
					</div>
				)}
			</div>
		);
	}
}

export default ResultSection;